import { getAllShiftFailure, getAllShiftSuccess, addNewShiftFailure, addNewShiftSuccess, editShiftFailure, editShiftSuccess, deleteShiftFailure, deleteShiftSuccess } from "../constants/shift";

const initialState = {
  isProcessing: false,
  isError: false,
  addNewShiftError:false,
  editExistingShiftError: false,
  deleteExistingShiftError: false,
  data: []
}

function handleReducer(state=initialState, action) {
  switch(action.type) {

    case getAllShiftFailure:
      return {...state, isError: true};

    case getAllShiftSuccess:
      return {...state, data: action.payload};

    case addNewShiftSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: [...(state.data?.object || []), ...action.payload],
          totalCount: (state.data?.totalCount || 0) + action.payload.length,
        },
      };
    
    case addNewShiftFailure:
      return {...state, addNewShiftError: true};

    case editShiftSuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: state.data.object.map((shift) =>
            shift.id === action.shiftId ? { ...shift, ...action.payload } : shift
          ),
        },
        editExistingShiftError: false,
      };
      
    case editShiftFailure:
      return {
        ...state,
        editExistingShiftError: true
      };
    
    case deleteShiftSuccess:
      return {
        ...state,
        data: state.data.filter((shift) => shift.id !== action.payload),
        deleteExistingShiftError: false
      };

    case deleteShiftFailure:
      return { ...state, deleteExistingShiftError: true };
      
    default:
      return state;
  }
}

export function shiftReducer(state, action) {
  return handleReducer(state, action)
}